<div class="lithium-battery">
  <div class="lithium-battery__body">
    <div class="question">
      {{ question }}
    </div>
    <div class="options">
      @for (option of options; track option) {
        <div class="d-inline-block" [class.mx-1]="option.label !== 'Yes'">
          <kt-checkbox
            attr.id="lithium-battery-{{ option.label.toLowerCase() }}"
            [value]="selectedAnswer === option"
            [label]="option.label"
            [size]="20"
            [disableUntick]="true"
            (onToggle)="selectAnswer(option)"
          >
          </kt-checkbox>
        </div>
      }
    </div>
  </div>
</div>
